<template>
  <div class="animated fadeIn" id="iframediv">
    <highcharts v-if="attiva" :options="chartOptions"></highcharts>
    <h1 v-if="!attiva">Funzione attiva solo dal 5 al 7 del mese</h1>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'dashboard',
  components: {
        highcharts: Chart 
  },
  data: function () {
    return {
        chartOptions: {     }
    }
  },
  computed: {
    attiva: function(){
      var oggi = new Date()
      return (oggi.getDate()>=5 && oggi.getDate()<=7)
    }
  },
  props: [  ],
  methods: {
  },
  mounted: function(){
    var me = this
    this.$http.get(window.baseurl+'/tshowpuntipers').then(response => {
        // console.log("RESP:",response.data)
        me.chartOptions = response.data
    })
  }
}
</script>

<style>
</style>
<style scoped>
</style>
